import React, { Component } from 'react'
import { render } from 'react-dom'
import Search from './search';
import Calendar from './calendar';
import CalendarMobile from './calendar-mb';
import Guests from './guests';
import { defaultStay, openingDateForCurrentProperty, stayPayload } from './bookingDates';


class BookNowForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      bookNowUrl : '',
      finalurl: '',
      calendarUrl: '',
      guestUrl: '&adult=2&child=0&childages=0&rooms=1',
      text_cosi: <div className="cosi_text">{Drupal.t("WHAT'S")} <span>{Drupal.t("THE DATE ?")}</span></div>,
      ppt_name: [],
      ppt_fast: [],
      hide_flexi: true,
      isHotel: true,
      inputPromoCode: '',
      isMobile: window.matchMedia("(max-width: 767px)").matches,
      isPromoCodeValid: true,
      openingDate: openingDateForCurrentProperty(),
    }
  }

  setBookNowUrl = (url) => {
    this.setState({
      bookNowUrl: url
    })
  }

  setOpeningDate = (openingDate) => {
    this.setState({
      openingDate: openingDate || ''
    })
  }

  setFlexi = (data) => {
    var name = data.fastbooking_property_id;
    if (drupalSettings.is_sabre) {
      name = data.sabre_property_id;
    }

    this.setState({
      ppt_name: name,
      ppt_fast: data.ppt_fast
    })
  }

  setCalendarData = (payload) => {
    if (drupalSettings.is_sabre) {
      var calendar_url = '&arrive=' + payload.fromyear + '-' + payload.frommonth + '-' + payload.fromday + '&depart=' + payload.toyear + '-' + payload.tomonth + '-' + payload.dayto
    }
    else {
      var calendar_url = '&frommonth=' + payload.frommonth + '&fromday=' + payload.fromday + '&fromyear=' + payload.fromyear + '&nbdays=' + payload.nbdays + '&iR_accesskey=' + this.getCookie('irewards_accesskey') + '&iR_member=' + this.getCookie('irewards_member_id')
    }
    this.setState ({
      calendarUrl : calendar_url
    },() => {
      }
    )
    return calendar_url;
  }

  setGuestData = (payload) => {
    if (drupalSettings.is_sabre) {
      var guest_url = '&adult=' + payload.adulteresa + '&child=' + payload.enfantresa + '&childages=' + payload.childrenAges + '&rooms=' + payload.roomCount
    }
    else {
      var guest_url = '&adulteresa=' + payload.adulteresa + '&enfantresa=' + payload.enfantresa + '&childrenAges1=' + payload.childrenAges
    }
    this.setState ({
      guestUrl: guest_url
    })
  }

  getCookie(key) {
    const irewards = (window.drupalSettings && window.drupalSettings.centaraIrewards) || {};
    const irewardsMap = {
      irewards_accesskey: 'accessKey',
      irewards_member_id: 'memberId',
    };
    if (irewardsMap[key] && irewards[irewardsMap[key]]) {
      return irewards[irewardsMap[key]];
    }
    let b = document.cookie.match('(^|;)\\s*' + key + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
  }

  removeParamsByKey(url, keysToRemove) {
    if(url){
      let urlObj = new URL(url);
      let params = new URLSearchParams(urlObj.search);
      keysToRemove.forEach(key => {
          params.delete(key);
      });
  
      urlObj.search = params.toString();
      return urlObj.toString();
    } else{
      return ""
    }
  }

  setFinalUrl = () => {
    this.state.isHotel = true;
    if(drupalSettings.is_sabre && ((typeof this.state.ppt_name !== 'string' && this.state.ppt_name.length === 0) || this.state.ppt_name === '')) {
      this.state.isHotel = false;
    }

    var checker;
    var url_path;
    if(typeof(drupalSettings.property_page) != "undefined") {
      checker = drupalSettings.property_page.ppty_id;
      if (drupalSettings.is_sabre) {
        var properties_data = JSON.parse(drupalSettings.centara_sabre.booknow_property_data);
      }
      else {
        var properties_data = JSON.parse(drupalSettings.centara_fastbooking.booknow_property_data);
      }
      properties_data.map(function(er, i) {
        Object.keys(er).forEach(function(key) {
          if(er[key] === checker) {
            url_path = er.book_now_url;
          }
        });
      })
      if(this.state.calendarUrl == ""){
        const stay = defaultStay(this.state.openingDate);
        let dateObj = stayPayload(stay.from, stay.to);

        this.setCalendarData(dateObj);
        var calendarUrlCurrent = this.setCalendarData(dateObj);
      }
      var calendarUrlActive = calendarUrlCurrent ? calendarUrlCurrent : this.state.calendarUrl;
      if (url_path && calendarUrlActive && this.state.guestUrl && this.state.isHotel) {
        this.setState ({
          finalurl: url_path + calendarUrlActive + this.state.guestUrl
        },() => {
          var currency_code = this.getCookie('currency_code');
          if (currency_code == '') {
            currency_code = 'THB';
          }
          var final_url_arr = this.state.finalurl.split('?')[1].replace(/&amp;/g, '&').split('&');
          final_url_arr.forEach(function(item, index) {
            if (item.indexOf('currency=') !== -1) {
              if (item !== "currency=" + currency_code) {
                final_url_arr[index] = "currency=" + currency_code;
              }
            }
          });
          this.state.finalurl = this.state.finalurl.split('?')[0] + '?' + final_url_arr.sort().join('&');
          let isPromoCode = this.state.inputPromoCode.trim() === '';
          let encoded;
          if(this.state.isPromoCodeValid){
            if (isPromoCode) {
              encoded = window.encodeURIComponent(this.state.finalurl);
            } else {
              encoded = window.encodeURIComponent(this.state.finalurl + `&promo=${this.state.inputPromoCode}` + `&config=${this.state.inputPromoCode}`);
            }
            let gl = (typeof _GA4CrossDomain !== 'undefined' && _GA4CrossDomain && _GA4CrossDomain._gl) ? _GA4CrossDomain._gl : '';
            let url = gl ? `/sabre-booking?url=${encoded}&_gl=${gl}` : `/sabre-booking?url=${encoded}`;
            window.open(url, '_blank');
          }
        })
      }
    }
    else {
      let cleanedUrl = this.removeParamsByKey(this.state.bookNowUrl, ["arrive", "depart"]);
      this.setState ({
        finalurl: cleanedUrl + this.state.calendarUrl + this.state.guestUrl
      },() => {
        if (drupalSettings.is_sabre) {
          if (this.state.bookNowUrl && this.state.bookNowUrl.split('?')[1]) {
            var bookNowUrlArr = this.state.bookNowUrl.split('?')[1].split('&');
            var currency_code = this.getCookie('currency_code');
            if (currency_code == '') {
              currency_code = 'THB';
            }
            if (this.state.bookNowUrl.indexOf('currency') === -1) {
              bookNowUrlArr.push("currency=" + currency_code);
            }
            this.state.bookNowUrl = this.state.bookNowUrl.split('?')[0] + '?' + bookNowUrlArr.sort().join('&');
            var final_url_arr = this.state.finalurl.split('?')[1].replace(/&amp;/g, '&').split('&');
            final_url_arr.forEach(function(item, index) {
              if (item.indexOf('currency=') !== -1) {
                if (item !== "currency=" + currency_code) {
                  final_url_arr[index] = "currency=" + currency_code;
                }
              }
            });

            this.state.finalurl = this.state.finalurl.split('?')[0] + '?' + final_url_arr.sort().join('&');
            this.state.bookNowUrl = this.state.finalurl;
          }
        }
        if (this.state.isHotel && this.state.isPromoCodeValid) {
          let isPromoCode = this.state.inputPromoCode.trim() === '';
          let encoded;
          if (isPromoCode) {
            encoded = window.encodeURIComponent(this.state.finalurl);
          } else {
            encoded = window.encodeURIComponent(this.state.finalurl + `&promo=${this.state.inputPromoCode}` + `&config=${this.state.inputPromoCode}`);
          }
          let gl = (typeof _GA4CrossDomain !== 'undefined' && _GA4CrossDomain && _GA4CrossDomain._gl) ? _GA4CrossDomain._gl : '';
          let url = gl ? `/sabre-booking?url=${encoded}&_gl=${gl}` : `/sabre-booking?url=${encoded}`;
          window.open(url, '_blank');
        }
      })
    }
  }
  handleInputPromoCode = (event) => {
    var regex = /^[A-Za-z0-9]{6,12}$/;
    const value = event.target.value;
  
    if (value === "" || regex.test(value)) {
      this.setState({ isPromoCodeValid: true });
    } else {
      this.setState({ isPromoCodeValid: false });
    }
  
    this.setState({ inputPromoCode: value });
  };
  
  componentDidMount = () => {
    if(typeof(drupalSettings.property_page) != "undefined") {
      var ppt_trans = drupalSettings.property_page.ppty_id;
      var property_fast_booking_id = '';
      var title = '';
      if (drupalSettings.is_sabre) {
        var properties_data = JSON.parse(drupalSettings.centara_sabre.booknow_property_data);
      }
      else {
        var properties_data = JSON.parse(drupalSettings.centara_fastbooking.booknow_property_data);
      }
      properties_data.map(function(er, i) {
        Object.keys(er).forEach(function(key) {
          if(er.ppty_id === ppt_trans) {
            property_fast_booking_id = er.field_sabre_property_id;
            title = er.title;
          }
        });
      });
      this.setState({
        ppt_name: property_fast_booking_id,
        ppt_fast: title,
        hide_flexi: false
      });
    }
  }
  render() {
    return  (
      <div className="booking-modal-wrapper">
        <div className="booknow-form-top-wrapper">
          <div className={'search-input' + (this.state.hide_flexi ? '': 'd-no')}>
            <Search
              setBookNowUrl = {this.setBookNowUrl}
              setOpeningDate = {this.setOpeningDate}
              setFlexi = {this.setFlexi}
              isHotel = {this.state.isHotel}
            />
          </div>
          <div className="set-flexi" name={this.state.ppt_name} value={this.state.ppt_fast}></div>
          <div className={'dates-input '+ (this.state.hide_flexi ? '' : 'm-bottom-margin')}>
            <label> { drupalSettings.ajaxPageState.theme === "centara_cosi" ? this.state.text_cosi : Drupal.t("Dates")  } </label>
            <div className={`input-wrapper ${!this.state.isMobile && "desktop"}`}>
              {
                this.state.isMobile ? (<CalendarMobile
                  setCalendarData = {this.setCalendarData}
                  openingDate = {this.state.openingDate}
                />) : (<Calendar
                  setCalendarData = {this.setCalendarData}
                  openingDate = {this.state.openingDate}
                />)
              }
            </div>
          </div>
          <div className="guest-input">
            <Guests
              setGuestData = {this.setGuestData}
            />
          </div>
          <div className="promo-code">
            <input type="text"
              className="promo-code-input"
              value={this.state.inputValue}
              onChange={this.handleInputPromoCode}
              placeholder={ Drupal.t('Promo Code') } />
              
            {this.state.isPromoCodeValid && this.state.inputPromoCode !== '' ? (
                <input
                  className='input-config'
                  type="hidden"
                  name="config"
                  value={this.state.inputPromoCode}
                />
              ) 
            : null }
          </div>

          <div className="book-now-button">
            {/* {
              drupalSettings.ajaxPageState.theme != "centara_main" ?
              <div className="best-text">
                <span className="right-icon"></span><a target="_blank" href="/best-rate-guarantee/">{ Drupal.t("Best Price Guaranteed")}{ drupalSettings.ajaxPageState.theme === "centara_cosi"? " !": " " }</a>
              </div> : ""
            } */}
            <div className="btn--primary" onClick = {this.setFinalUrl}> {Drupal.t("Book Now")} </div>
          </div>
        </div>
        <div className="checkmark-wrapper">
          <div className="checkmark-content">
            <div className="checkmark"></div>
            <span>
              <a target="_blank" href="/best-rate-guarantee/">{ Drupal.t("Best rate guaranteed")}</a>
            </span>
          </div>
        </div>
        <div className="flexi-wrapper">
          <div id="flexi-click" className={'flexi-link ' + (this.state.hide_flexi? 'd-no' : '')} onClick={drupalSettings.is_sabre === 1 ? this.setFinalUrl : undefined}>
              <a target="_blank" href="/best-rate-guarantee/">
                { Drupal.t("Flexible with your dates?")}
              </a>
            </div>
        </div>
      </div>
    );
  }
}

export default BookNowForm;
